module.exports = "{{card.brand}} XXXX-XXXX-XXXX-XXXX-{{card.last4}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/billing-card/billing-card.component.html
// module id = ./src/app/shared/billing-card/billing-card.component.html
// module chunks = main